import { BaseInlineUpdateComponent, InlineContainerService } from 'yt-ng-framework';
import { Component, OnInit } from '@angular/core';
import { KozDokumentStavka } from './koz-dokument-stavka'

@Component({
  selector: 'yt-koz-dokument-stavka-inline-update',
  templateUrl: './koz-dokument-stavka-inline-update.component.html'
})

export class KozDokumentStavkaInlineUpdateComponent extends BaseInlineUpdateComponent<KozDokumentStavka> {
  constructor(protected inlineContainerService: InlineContainerService<KozDokumentStavka>){
    super(inlineContainerService);
  }
}
